











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
@Component({})
export default class AppTableDate extends Vue {
  @Prop({ type: Number }) readonly time!: number

  dateToDisplay = dateToDisplay
  dateTimeToDisplay = dateTimeToDisplay
}
